import React from 'react';
import moment from 'moment';
import propTypes from 'prop-types'
import commonMessage from 'src/utils/commonMessage.json';

//mui material
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Chip, Box, Typography, Icon, IconButton, Button, Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

//components
import NetworkError from 'src/components/Error/networkError';
import { CustomSkeleton } from '../../skeleton/skeletonLoader';
import Tooltip from '@mui/material/Tooltip';

import { nameFormater } from 'src/utils/common';

import InfoIcon from '@mui/icons-material/Info';
// import gLogin from './gLogo.png';

// Show table filtes.
const TableFilterSection = styled('div')(() => ({
  width: 'auto',
  padding: '16px 16px 16px 16px',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center'
}));

export const PaginationTable = ({
  TtsContentJsx,
  RouteJsx,
  AudioPlayerJsx,
  page = 0,
  tableFilter,
  ActionJsx,
  ActionModals,
  setPage,
  rowsPerPage = 10,
  setRowsPerPage,
  setLoad,
  count = 0,
  error = false,
  loading,
  setLoading,
  rows,
  columns,
  size = "small",
  calculatedHeight = 0,
  Template= "",
  LanguageJsx,
}) => {

  const handleChangePage = (e, newPage) => {
    setPage(newPage)
    setLoad(true)
    setLoading(true)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setLoad(true)
    setLoading(true)
  };

  const dateFormatJsx = (id, align, value) => {

    const dateFormatter =(timeStamp) => {
    const date = timeStamp.toString().length === 10
  ? moment(Number(timeStamp) * 1000)
  : moment(timeStamp);
    const formattedDate = date.format('D MMM, YYYY');
    const formattedTime = date.format('h:mm A');

    return `${formattedDate} ${formattedTime}`;
    }

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}>
        <>
          <Box>{value !== undefined && value !== null && value !== '' ? dateFormatter(value) : '-'}</Box>

        </>
      </TableCell>)
  }

  const roleFormatJsx = (id, align, value) => {
    const roleFormatMapper = {
      superAdmin: "Super-Admin",
      admin: "Admin",
      agent: "Agent"
    }

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}>
        {roleFormatMapper[value]}
      </TableCell>
    )

  }
  // const templateJsx = (id, align, value, row) => {
  //   return (
  //     <TableCell
  //       key={id}
  //       align={align}
  //       sx={{
  //         color: 'grey.700',
  //         borderBottom: '0.5px dashed',
  //         borderColor: 'grey.300',
  //       }}>
  //         <Template row={row} value={value} align={align} id={id}/>
  //     </TableCell>
  //   )
  // }
   const templateJsx = (id, align, value, row) => {
    return <Template  id={id} align={align} value={value} row={row} />
  }
  const defaultRowJsx = (id, align, value) => (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}>
      {value || "--"}
    </TableCell>
  )

  const userTypeJsx = (id, align, value) => (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}>
      {nameFormater(value || "--")}
    </TableCell>
  )



  const usedModuleJsx = (id, align, value, row) => {
    return <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}>
      <Tooltip title={value}>
        <IconButton>
          <InfoIcon />
        </IconButton>
      </Tooltip>
    </TableCell>
  }

  const routeJsx = (id, align, value, row) => {
    return <RouteJsx key={id} id={id} align={align} value={value} row={row} />
  }
  const languageJsx = (id, align, value, row) => {
    return <LanguageJsx key={id} id={id} align={align} value={value} row={row} />
  }

  const audioPlayerJsx = (id, align, value, row) => {
    return <AudioPlayerJsx key={id} id={id} align={align} value={value} row={row} />
  }

  const actionJsx = (id, align, value, row) => {
    return <ActionJsx key={id} id={id} align={align} value={value} row={row} />
  }

  const ttsContentJsx = (id, align, value, row) => {
    return <TtsContentJsx key={id} id={id} align={align} value={value} row={row} />
  }

  const rejectionReasonJsx = (id, align, value, row) => {
    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}>
        <Tooltip title={value}>
          {value?.length > 20 ? `${value.slice(0, 20)}...` : value || "--"}
        </Tooltip>
      </TableCell>
    )
  }

  const tableRowData = {
    create_date: dateFormatJsx,
    role: roleFormatJsx,

    userType: userTypeJsx,

    announcementUrl: audioPlayerJsx,
    actions: actionJsx,
    route: routeJsx,
    used_module: usedModuleJsx,
    ttsContent: ttsContentJsx,
    rejectionReason: rejectionReasonJsx,
    template: templateJsx,
    language: languageJsx,
  }

  return (
    <Paper sx={{
      overflow: 'hidden',
      backgroundColor: 'grey.1000',
      borderRadius: '6px'
    }}>

      <TableFilterSection>
        {tableFilter}
      </TableFilterSection>

      <TableContainer sx={{ maxHeight: window.innerHeight - calculatedHeight }}>
        <Table stickyHeader aria-label="sticky table" size={size}>

          <TableHead sx={{
            position: "sticky"
          }} >
            <TableRow >
              {columns.map(({ id, align, minWidth, label }) => (
                <TableCell
                  key={id}
                  align={align}
                  style={{ minWidth }}
                  sx={{
                    backgroundColor: 'grey.200',
                    color: 'grey.600',
                  }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {!loading ?
            <TableBody>
              {rows.map((row) =>
              (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row?.userId || row?.email}
                >
                  {columns.map(({ id, align }) => (tableRowData?.[id] || defaultRowJsx)(id, align, row[id], row))}
                </TableRow>
              )
              )}
            </TableBody>
            :
            <TableBody>
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
              >
                {columns.map(({ id, align }) => (
                  <TableCell
                    key={id}
                    align={align}
                    sx={{
                      color: 'grey.300',
                      borderBottom: '1px solid',
                      borderColor: 'grey.800',
                    }}
                  >
                    <CustomSkeleton variant={"text"} component={"h6"} width={"100%"} />
                  </TableCell>
                ))}
              </TableRow>

            </TableBody>
          }
        </Table>
      </TableContainer>

      {count > 0 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            backgroundColor: 'grey.1000',
            color: 'grey.700',
          }}
        />
      )}

      {!(count || loading) &&
        < Box sx={{
          height: {
            xs: "480px",
            sm: "480px",
            md: "480px",
            lg: "480px",
            xl: "670px",
          },
          display: 'flex',
          justifyContent: 'center'
        }}>
          <NetworkError message={!error ? commonMessage?.noDataFound : commonMessage?.networkError} calculatedHeight={calculatedHeight} />
        </Box>
      }
      {ActionModals && <ActionModals />}
    </Paper>
  )
}



PaginationTable.propTypes = {
  page: propTypes.number,
  setPage: propTypes.func.isRequired,
  rowsPerPage: propTypes.number,
  setRowsPerPage: propTypes.func.isRequired,
  setLoad: propTypes.func.isRequired,
  count: propTypes.number,
  error: propTypes.bool,
  loading: propTypes.bool,
  setLoading: propTypes.func,
  rows: propTypes.array.isRequired,
  columns: propTypes.array.isRequired,
  maxHeight: propTypes.number,
}
